import { render, staticRenderFns } from "./BottleSizeList.vue?vue&type=template&id=98f344c4"
import script from "./BottleSizeList.vue?vue&type=script&lang=ts"
export * from "./BottleSizeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports